import { Component, Injectable, OnDestroy } from "@angular/core";
import { Subject } from "rxjs";

/**  */
@Injectable({
  providedIn: 'root'
})
export class SubscriptionCleaner implements OnDestroy {
    private _isDestroyed = new Subject<boolean>();
    public get isDestroyed$() { return this._isDestroyed; }

    constructor() { }

    ngOnDestroy() {
        this._isDestroyed.next(true);
        this._isDestroyed.complete();
    }
}
